import useHttp from "../security/Http.hook";

export interface PricedSpring {
  id: number;
  name: string;
  materials: PricedSpringMaterial[];
  price: number;
  width: number;
  length: number;
}

interface PricedSpringMaterial {
  name: string,
  thickness: number;
}

export const getPricedSpringFormattedMaterialNames = (pricedSpring: PricedSpring) => {
  const materialNames = pricedSpring.materials.map(material => material.name);
  return Array.from(new Set(materialNames)).join(', ');
};

export const getPricedSpringFormattedMaterialsThickness = (pocketSpring: PricedSpring) => {
  const materialThicknesses = pocketSpring.materials
    .map(material => material.thickness)
    .sort(compareAscending);
  return Array.from(new Set(materialThicknesses)).join(' / ');
};

const compareAscending = (aNumber: number, anotherNumber: number) => aNumber - anotherNumber;

const usePricedSpringApi = () => {
  const http = useHttp();

  const fetchPricedBonnellSprings = (customerId: number, priceListId: number) : Promise<PricedSpring[]> =>
    http.get(`/api/customers/${customerId}/price-lists/${priceListId}/bonnell-springs`);

  const fetchPricedPocketSprings = (customerId: number, priceListId: number) : Promise<PricedSpring[]> =>
    http.get(`/api/customers/${customerId}/price-lists/${priceListId}/pocket-springs`);

  return {
    fetchPricedBonnellSprings,
    fetchPricedPocketSprings
  };
};

export default usePricedSpringApi;